import { getModel } from '@smx-ui-model/store-model';
import { GenericModelType, StoreModelType } from '@smx-ui-model/types';
import { Form } from 'antd';
import * as React from 'react';
import { memo, useEffect } from 'react';

interface LoaderDefaultDataFormInspectorProps {
    modelName: keyof StoreModelType;
}

const LoaderDefaultDataFormInspector: React.FC<LoaderDefaultDataFormInspectorProps> = ({ modelName }) => {
    const form = Form.useFormInstance();
    const model = getModel<GenericModelType>(modelName);

    useEffect(() => {
        if (!model.defaultData) {
            return;
        }
        const loadData: { [key: string]: string | number | object } = {};

        Object.keys(model.defaultData).forEach((fieldName) => {
            loadData[fieldName] = (model.defaultData as any)[fieldName]();
        });

        form.setFieldsValue({
            ...loadData,
        });
    }, [modelName]);

    return <></>;
};

export default memo(LoaderDefaultDataFormInspector);
